import React, { memo } from 'react'
import { Icon, Text } from 'common-components'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import * as Styled from './styled'
import CapabilityChips from '../CapabilityChips'
import UnlimitedBanner from '../UnlimitedBanner'
import { IDropdownModel, IUnlimitedBanner } from '../types'

interface IProps {
  model: IDropdownModel
  isSelected: boolean
  onSelect: () => void
  unlimitedBanner?: IUnlimitedBanner
}

const VariantRow: React.FC<IProps> = ({
  model,
  isSelected,
  onSelect,
  unlimitedBanner
}) => {
  const showUnlimitedBanner =
    unlimitedBanner && unlimitedBanner.modelKeys.includes(model.selectKey)

  return (
    <Styled.SubmenuVariantWrapper $isSelected={isSelected} onClick={onSelect}>
      <Styled.SubmenuVariantHeader>
        <Text
          type={isSelected ? 'subtitle' : 'h2'}
          color={isSelected ? 'secondaryDark' : 'secondarySemiDark'}
        >
          {model.name}
        </Text>
        {model.isPremium && (
          <Styled.CrownBadgeIcon
            icon={<CrownIcon />}
            size="small"
            color="goldDark"
          />
        )}
        {isSelected && (
          <Styled.SelectedCheck>
            <Icon icon={<CheckIcon />} size="medium" color="primaryDark" />
          </Styled.SelectedCheck>
        )}
      </Styled.SubmenuVariantHeader>
      <CapabilityChips labels={model.capabilityLabels} />
      {showUnlimitedBanner && (
        <UnlimitedBanner
          text={unlimitedBanner.text}
          highlightText={unlimitedBanner.highlightText}
          onClick={unlimitedBanner.onClick}
        />
      )}
    </Styled.SubmenuVariantWrapper>
  )
}

export default memo(VariantRow)
